import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { KbAPI } from "../../../api/kb";
import InternalNoteViewer from "../../../components/tiptap/InternalNoteViewer";

export default function KbArticlePage() {
  const { id } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    async function load() {
      try {
        const data = await KbAPI.getById(id);
        setArticle(data);
      } catch (err) {
        console.error(err);
        setError(err.message || "Failed to load article");
      } finally {
        setLoading(false);
      }
    }

    load();
  }, [id]);

  if (loading) return <p className="p-4">Loading…</p>;
  if (error) return <p className="p-4 text-red-500">Error: {error}</p>;
  if (!article) return <p className="p-4">Article not found</p>;

  return (
    <div className="p-4 max-w-4xl">
      <h1 className="text-2xl font-semibold mb-2">{article.title}</h1>
      <div className="text-sm text-gray-500 mb-4">
        {article.audience_type === "end_user" ? "End user" : "Technician"}
      </div>

      <div className="border rounded p-4 bg-white">
        <InternalNoteViewer value={article.body} />
      </div>
    </div>
  );
}